/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./recaptcha.component";
import * as i2 from "./recaptcha-loader.service";
import * as i3 from "./recaptcha-settings";
var styles_RecaptchaComponent = [];
var RenderType_RecaptchaComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_RecaptchaComponent, data: {} });
export { RenderType_RecaptchaComponent as RenderType_RecaptchaComponent };
export function View_RecaptchaComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_RecaptchaComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "re-captcha", [], [[1, "id", 0]], null, null, View_RecaptchaComponent_0, RenderType_RecaptchaComponent)), i0.ɵdid(1, 4374528, null, 0, i1.RecaptchaComponent, [i0.ElementRef, i2.RecaptchaLoaderService, i0.NgZone, [2, i3.RECAPTCHA_SETTINGS]], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).id; _ck(_v, 0, 0, currVal_0); }); }
var RecaptchaComponentNgFactory = i0.ɵccf("re-captcha", i1.RecaptchaComponent, View_RecaptchaComponent_Host_0, { id: "id", siteKey: "siteKey", theme: "theme", type: "type", size: "size", tabIndex: "tabIndex", badge: "badge" }, { resolved: "resolved" }, []);
export { RecaptchaComponentNgFactory as RecaptchaComponentNgFactory };
